import React, { MouseEvent } from 'react';
import moment from 'moment';
import Typography from '@mui/material/Typography';
import classnames from 'classnames';
import styles from './styles.module.css';

const Event = (props: EventProps) => {
  const className = classnames(styles[props.theme], {
    [styles.highlighted]: props.isHighlighted,
    [styles.dimmed]: props.isDimmed,
  });
  return (
    <button
      type="button"
      className={className}
      onClick={props.onClick}
      aria-pressed={props.isHighlighted}
    >
      <Typography variant="subtitle2" align="left">
        {`${moment(props.startDate).format('LT')} - ${moment(
          props.endDate
        ).format('LT')}`}
      </Typography>
      {props.children}
    </button>
  );
};

type EventProps = {
  children: React.ReactNode;
  startDate: string;
  endDate: string;
  theme:
    | 'gray'
    | 'cyan'
    | 'green'
    | 'green-striped'
    | 'red'
    | 'orange'
    | 'orange-striped'
    | 'blue';
  isHighlighted?: boolean;
  isDimmed?: boolean;
  onClick?: React.EventHandler<MouseEvent>;
};

Event.displayName = 'Event';

export default Event;
